// extracted by mini-css-extract-plugin
module.exports = {"star":"AverageRating_star__7wf5s","averageRating":"AverageRating_averageRating__JnFbu","templatesLength":"AverageRating_templatesLength__R3LxQ"};